export default __webpack_public_path__ + "static/media/feature2.2b82940d.jpg";